import { VisitorGroup } from 'graphql/generated/graphqlTypes';
import { visitorsGroupsVar } from 'state/vars';

export const setVisitorsGroupsAction = (visitorsGroups: VisitorGroup[]) => {
  visitorsGroupsVar(visitorsGroups);
};

export const setAccessGrantsForGroupAction = (accessGrantsForGroup: VisitorGroup) => {
  const currentVisitorGroups = visitorsGroupsVar();
  const updatedVisitorGroups: VisitorGroup[] = (currentVisitorGroups as VisitorGroup[]).map((visitorGroup) => {
    if (visitorGroup.id === accessGrantsForGroup.id)
      return {
        ...visitorGroup,
        accessGrants: accessGrantsForGroup.accessGrants
      };
    return {
      ...visitorGroup
    };
  });
  visitorsGroupsVar(updatedVisitorGroups);
};
